import domain from '../domain';

const onMapCaptureClick = domain.event();

export default onMapCaptureClick;
